import { Home, CV, Projects, Flying } from '../pages';

export const routes = [
    {
        path: '/',
        component: Home,
        label: 'Home'
    },
    {
        path: '/cv',
        component: CV,
        label: 'CV'
    },
    {
        path: '/projects',
        component: Projects,
        label: 'Projects'
    },
    {
        path: '/flying',
        component: Flying,
        label: 'Flying'
    }
]; 